module.exports = __webpack_public_path__ + "img/36.96eae0ff.png";